import { render, staticRenderFns } from "./VistaPadres.vue?vue&type=template&id=098960c0&"
import script from "./VistaPadres.vue?vue&type=script&lang=js&"
export * from "./VistaPadres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports